import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CreateListIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M7.52941 7.5C7.52941 6.94772 7.97713 6.5 8.52941 6.5H15.5882C16.1405 6.5 16.5882 6.94772 16.5882 7.5C16.5882 8.05228 16.1405 8.5 15.5882 8.5H8.52941C7.97713 8.5 7.52941 8.05228 7.52941 7.5ZM7.52941 11.1C7.52941 10.5477 7.97713 10.1 8.52941 10.1H13.8235C14.3758 10.1 14.8235 10.5477 14.8235 11.1C14.8235 11.6523 14.3758 12.1 13.8235 12.1H8.52941C7.97713 12.1 7.52941 11.6523 7.52941 11.1ZM7.52941 14.7C7.52941 14.1477 7.97713 13.7 8.52941 13.7H10.2941C10.8464 13.7 11.2941 14.1477 11.2941 14.7C11.2941 15.2523 10.8464 15.7 10.2941 15.7H8.52941C7.97713 15.7 7.52941 15.2523 7.52941 14.7ZM16.5936 15C17.1459 15 17.5936 15.4477 17.5936 16V17.5259L18.9815 17.5002C19.5337 17.4899 19.9896 17.9293 19.9998 18.4815C20.0101 19.0337 19.5707 19.4896 19.0185 19.4998L17.5936 19.5262V21C17.5936 21.5523 17.1459 22 16.5936 22C16.0413 22 15.5936 21.5523 15.5936 21V19.5633L14.0185 19.5924C13.4663 19.6026 13.0104 19.1633 13.0002 18.6111C12.9899 18.0589 13.4293 17.603 13.9815 17.5928L15.5936 17.5629V16C15.5936 15.4477 16.0413 15 16.5936 15Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M4 5.5C4 3.567 5.567 2 7.5 2H16.5C18.433 2 20 3.567 20 5.5V13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13V5.5C18 4.67157 17.3284 4 16.5 4H7.5C6.67157 4 6 4.67157 6 5.5V18.5C6 19.3284 6.67157 20 7.5 20H11C11.5523 20 12 20.4477 12 21C12 21.5523 11.5523 22 11 22H7.5C5.567 22 4 20.433 4 18.5V5.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CreateListIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CreateListIcon);
